/**
 * ==========================================================
 * NUPEP Catalogue
 * Version: 4.1.0
 * Shopify Section Rendering API
 * ==========================================================
 */

window.NUPEP = window.NUPEP || {};

NUPEP.Catalogue = (() => {
  let section;
  let loading = false;

  function init() {
    section = document.getElementById("nupep-catalogue-section");

    if (!section) return;

    bindEvents();

    bindHistory();
  }

  function bindEvents() {
    bindSort();
  }

  function bindSort() {
    const sort = document.querySelector(".nupep-sort");

    if (!sort) return;

    sort.addEventListener("change", () => {
      updateCollection({
        sort_by: sort.value,
      });
    });
  }

  async function updateCollection(params = {}) {
    if (loading) return;

    loading = true;

    showLoading();

    try {
      const url = new URL(window.location.href);

      Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, value);
      });

      url.searchParams.set("section_id", "nupep-all-products");

      const response = await fetch(url.toString());

      const html = await response.text();

      replaceSection(html);

      history.pushState({}, "", url.pathname + url.search);
    } catch (error) {
      console.error(error);
    } finally {
      hideLoading();

      loading = false;
    }
  }

  function replaceSection(html) {
    const parser = new DOMParser();

    const documentHTML = parser.parseFromString(html, "text/html");

    const newSection = documentHTML.querySelector("#nupep-catalogue-section");

    if (!newSection) return;

    section.replaceWith(newSection);

    section = newSection;

    bindEvents();
  }

  function showLoading() {
    section.classList.add("is-loading");
  }

  function hideLoading() {
    section.classList.remove("is-loading");
  }

  function bindHistory() {
    window.addEventListener("popstate", () => {
      location.reload();
    });
  }

  return {
    init,
  };
})();

document.addEventListener("DOMContentLoaded", () => {
  NUPEP.Catalogue.init();
});
